import type { ProjectWithInterviewCount } from "@repo/app-types/entities/project";
import { getIsTrainingProject } from "@repo/app-types/helpers/utilities";
import { Button, ButtonVariant } from "@repo/ui/Buttons/button";
import { Size } from "@repo/ui/helpers/helpers";
import { IconMessageCircle } from "@tabler/icons-react";
import { type FC, useState } from "react";
import { InterviewSimulationSlideover } from "./interviewSimulationSlideover.js";

interface InterviewSimulationButtonProps {
  project: ProjectWithInterviewCount;
}

export const InterviewSimulationButton: FC<InterviewSimulationButtonProps> = ({
  project,
}) => {
  const [isSlideoverOpen, setIsSlideoverOpen] = useState(false);
  const buttonLabel = getIsTrainingProject(project)
    ? "Try this training"
    : "Try this interview";

  return (
    <>
      <Button
        variant={ButtonVariant.Secondary}
        size={Size.MEDIUM}
        onClick={() => setIsSlideoverOpen(true)}
        icon={<IconMessageCircle className="h-4 w-4" />}
      >
        {buttonLabel}
      </Button>

      <InterviewSimulationSlideover
        project={project}
        isOpen={isSlideoverOpen}
        onClose={() => setIsSlideoverOpen(false)}
      />
    </>
  );
};
